<template>
  <div class="tab-profile">
    <div class="profile-main-wrapper">
      <div class="profile-main-content">
        <form class="form-register">
          <div v-for="item in formList"
               :class="['form-item',item.is_require?'form-item-required':'','form-item-'+item.key]">
            <label class="my-label" for="" :style="$parent.labelStyle">{{ item.name }}</label>
            <div class="input-wrapper">
              <input type="text"
                     v-model="item.value"
                     class="member-input"
                     ::aria-placeholder="$t('widgets_basic_member_center_components_tab_profile_2614', [item.name])"
                     ::placeholder="$t('widgets_basic_member_center_components_tab_profile_2614', [item.name])"
                     :disabled="item.key=='email' || item.key=='mobile'"
                     :style="$parent.contentStyle">
              <button class="btn-edit" v-if="item.key==='email'||item.key==='mobile'" @click="onClickProfileEditBtn">{{$t('widgets_basic_member_center_components_tab_profile_2615')}}</button>
            </div>
          </div>
          <div class="form-item">
            <span class="label-placeholder"></span>
            <button class="btn-register" type="button" @click="onClickConfirmBtn" :style="$parent.buttonStyle">{{$t('widgets_basic_member_center_components_tab_password_2605')}}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../language/index'

import {
  getUserRegConfig
} from "@/api/app.js";

export default {
  name: "basic_member_center_profile.vue",
  props: {},
  data() {
    return {
      formList: []
    }
  },
  methods: {
    onClickProfileEditBtn() {
      this.$message.info(i18n.t('widgets_basic_member_center_components_tab_profile_2616'))
    },
    onClickConfirmBtn() {
      this.$message.info(i18n.t('components_set_link_components_submit_form_index_2470'))
    },
    getRegConfig() {
      getUserRegConfig().then(data => {
        console.log('注册表单：', data)
        // this
        data = data.data || {}
        let formList = data.reg_select || []
        let mockData = {
          "username": i18n.t('widgets_basic_member_center_components_tab_profile_2617'),
          phone: '13512345678',
          "mobile": "13512345678",
          "tel": "021",
          "address": i18n.t('widgets_basic_member_center_components_tab_profile_2618'),
          "realname": i18n.t('widgets_basic_job_components_table1_2522'),
          "email": "test@test.com",
          "wechat": "wangxiaoming",
          "qq": "123456",
          "company": i18n.t('widgets_basic_member_center_components_tab_profile_2619')
        }
        formList.forEach(item => {
          item.value = mockData[item.key]
        })
        this.formList = formList
      })
    }
  },
  created() {
    this.getRegConfig()
  }

}
</script>

<style lang="scss" scoped>
.tab-profile {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;
}

.register-title {
  color: var(--theme_color);
  font-size: 24px;
  margin-top: 20px;
}

.register-tip {
  font-size: 18px;
  margin-top: 10px;
}

.form-item {
  display: flex;
  align-items: center;
  margin-top: 20px;

  .my-label {
    width: 5em;
    text-align: right;
  }

  &.form-item-required {
    .my-label:before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .label-placeholder {
    width: 5em;
  }
}

.member-input {
  display: inline-block;
  //width: 400px;
  flex: 1;
  height: 45px;
  line-height: 45px;
  background: #F7F8FB;
  border-radius: 3px;
  padding-left: 10px;
  border: 1px solid transparent;
  outline: none;
  margin-left: 20px;
}

.form-item-terms-content {
  display: flex;
  justify-content: space-between;
  flex: 1;
  //width: 400px;
  padding-left: 20px;
}

.text-highlight {
  color: var(--theme_color);
}

.checkbox-read-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.btn-register {
  //width: 400px;
  flex: 1;
  height: 45px;
  line-height: 45px;
  background: var(--theme_color);
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  margin-left: 20px;
}

.tab-profile {
  .register-title, .register-tip {
    text-align: center;
  }

  .profile-main-wrapper {
    width: 100%;
    max-width: 500px;
  }

  .member-input {
    border: 1px solid transparent;

    &:hover {
      border-color: var(--theme_color);
    }

    &:focus {
      border-color: var(--theme_color);
    }
  }
}

input::-webkit-input-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

input:-moz-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

input::-moz-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

input:-ms-input-placeholder {
  font-style: inherit;
  text-decoration: inherit;
  font-size: inherit;
  color: inherit;
  font-weight: inherit;
  font-family: inherit;
  text-align: inherit;
  background-image: inherit;
  -webkit-background-clip: text;
}

// 新增需求，修改手机、邮箱
.tab-profile {
  .form-item-mobile, .form-item-email {
    .member-input {
      background: transparent;

      &:hover {
        border-color: transparent;
      }
    }
  }

  .btn-edit {
    position: absolute;
    right: 0;
    cursor: pointer;
    background: transparent;
    border: none;
    color: #02A7F0;
    top: 50%;
    transform: translateY(-50%);
  }
}

// 加上 error tip 后新增的代码
.tab-profile {
  .input-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    width: 100%;

    .error-tip {
      position: absolute;
      top: 100%;
      color: #f56c6c;
      font-size: 12px;
    }
  }
}

// 下面是移动端的
.mb_pattern .tab-profile {
  .profile-main-wrapper {
    width: 53%;
    display: flex;
    justify-content: flex-end;
    padding-right: 5%;
  }

  .form-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .form-item-required .my-label:before {
    position: absolute;
    left: -10px;
  }

  .member-input {
    width: 100%;
    margin-left: 0;
    padding-left: 0;
  }

  .label-placeholder {
    display: none;
  }

  .my-label {
    width: auto;
  }

  .member-input {
    background: transparent;
    border: none;
    border-bottom: 1px solid #b0b0b0;

    &:hover {
      border-bottom: 1px solid var(--theme_color);
    }

    &:focus {
      border-bottom: 1px solid var(--theme_color);
    }
  }

  .form-item-terms-content {
    width: 100%;
    padding-left: 0;
  }

  .btn-register {
    width: 100%;
    margin-left: 0;
  }

}

.mb_pattern .tab-profile {
  .profile-main-wrapper {
    width: 100%;
    order: 2;
    padding-left: 5%;
    padding-right: 5%;
  }

  .profile-main-content {
    padding-left: 0;
    width: 100%;
  }

  .img-wrapper {
    width: 100%;
    order: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/widgets/basic_member_center/components/tab-profile.vue